class AppDownloadButtons extends HTMLElement {
  constructor() {
    super();
    this.UA = navigator.userAgent;
    this._raf = null;
    this.onResize = this.onResize.bind(this);
  }

  get isIOS() {
    return (
      /iPhone|iPad|iPod/i.test(this.UA) ||
      (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)
    );
  }

  get isAndroid() {
    return /Android/i.test(this.UA);
  }

  get isMobileViewport() {
    return window.innerWidth < 1024;
  }

  connectedCallback() {
    this.render();
    window.addEventListener('resize', this.onResize);
  }

  disconnectedCallback() {
    window.removeEventListener('resize', this.onResize);
    if (this._raf) {
      cancelAnimationFrame(this._raf);
    }
  }

  onResize() {
    cancelAnimationFrame(this._raf);
    this._raf = requestAnimationFrame(() => this.render());
  }

  getSvgContent(svgName) {
    const template = this.querySelector(
      `template[data-svg-name="${svgName}"]`
    );

    if (template?.content) {
      return template.innerHTML;
    }

    return `
      <div class="h-full w-full bg-gray-200 flex items-center justify-center text-xs">
        ${svgName}
      </div>
    `;
  }

  buildButton({ url, svgName, width }) {
    if (!url) return '';

    return `
      <a
        href="${url}"
        target="_blank"
        rel="noopener"
        class="flex justify-center items-center h-[40px] [contain:size]"
        style="width: ${width}px;"
      >
        ${this.getSvgContent(svgName)}
      </a>
    `;
  }

  buildMarkup({ iosUrl, androidUrl }) {
    const iosButton = this.buildButton({
      url: iosUrl,
      svgName: this.dataset.iosSvgName || 'ios-download',
      width: 120
    });

    const androidButton = this.buildButton({
      url: androidUrl,
      svgName: this.dataset.androidSvgName || 'android-download',
      width: 136
    });

    if (this.isIOS && iosButton) return iosButton;
    if (this.isAndroid && androidButton) return androidButton;

    if (!this.isIOS && !this.isAndroid && (iosButton || androidButton)) {
      const hideAndroid =
        this.isMobileViewport && iosButton && androidButton;

      return `
        <div class="flex flex-col sm:flex-row gap-2 items-center justify-center">
          ${iosButton}
          ${hideAndroid ? '' : androidButton}
        </div>
      `;
    }

    return '';
  }

  render() {
    const container = this.querySelector('.app-download-container');
    if (!container) return;

    container.innerHTML = this.buildMarkup({
      iosUrl: this.dataset.iosUrl,
      androidUrl: this.dataset.androidUrl
    });
  }
}

customElements.define('app-download-buttons', AppDownloadButtons);
